import { getIconViewIconCentreOffset } from '../../../utils/dnd/dragAndDropUtils';

// Helpers
import * as pointLib from '../../../../common/maths/geometry/point';
import { isLine } from '../../../../common/elements/utils/elementTypeUtils';
import { isIconViewLike } from '../../../../common/elements/utils/elementDisplayUtils';

// Constants
import { DEFAULT_NEW_ELEMENT_DRAG_OFFSET_GRID_UNITS } from '../../../utils/dnd/dndConstants';
import { DEFAULT_LINE_WIDTH, DEFAULT_LINE_HEIGHT } from '../../../../common/lines/lineConstants';

/**
 * Need to reposition lines so that the arrow is being held right in the middle.
 */

const getNewIconViewIconCentreOffset = ({ gridSize }) => pointLib.scale(-1, getIconViewIconCentreOffset({ gridSize }));

const getNewLineDragOffset = ({ gridSize }) =>
    pointLib.scale(-gridSize, pointLib.getPoint(DEFAULT_LINE_WIDTH / 2, DEFAULT_LINE_HEIGHT / 2));

const getDefaultDragDropPosition = ({ gridSize }) =>
    pointLib.scale(-gridSize, DEFAULT_NEW_ELEMENT_DRAG_OFFSET_GRID_UNITS);

export const getDefaultElementOffset = ({ element, gridSize }) => {
    if (isIconViewLike(element)) return getNewIconViewIconCentreOffset({ gridSize });
    if (isLine(element)) return getNewLineDragOffset({ gridSize });
    return getDefaultDragDropPosition({ gridSize });
};
